import { render, staticRenderFns } from "./UserManualView.vue?vue&type=template&id=4237aeb0&scoped=true"
import script from "./UserManualView.vue?vue&type=script&lang=js"
export * from "./UserManualView.vue?vue&type=script&lang=js"
import style0 from "./UserManualView.vue?vue&type=style&index=0&id=4237aeb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4237aeb0",
  null
  
)

export default component.exports